<template>
  <div class="news">
    <div class="box30"></div>
    <div class="w1200 container-detail">
      <h3>{{item.listTitle}}</h3>
      <div class="line"></div>
      <div class="desc clear">
        <em>{{item.addTime1}}</em>
        <em>来源：{{item.source}}</em>
        <em>作者：{{item.author}}</em>
        <em class="img" @click="shareWx"></em>
      </div>
      <!-- <el-image :src="item.imgs" v-if="item.imgs" lazy></el-image> -->
      <div class="details" v-html="item.content">
      </div>
    </div>

    <div class="d_footer">
      <h4>欢迎垂询</h4>
      <p>欢迎关注官方微信“数说产业互联网”，阅读更多精彩文章。也可以扫描下方二维码添加关注。数说产业互联网将为您提供更多解决方案</p>
      <div class="box20"></div>
      <ul class="imgList w1200 clear">
        <li>
          <div class="mask">
            <div class="desc">
              <p>乡村振兴数字化解决方案</p>
              <div class="link" @click="routerLink('/solution/0')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_01.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农业单品行业大数据解决方案</p>
              <div class="link" @click="routerLink('/solution/1')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_02.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农业链主企业数字 化解决方案</p>
              <div class="link" @click="routerLink('/solution/2')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_03.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>现代农业产业园数 字化解决方案</p>
              <div class="link" @click="routerLink('/solution/3')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_04.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农产品区域公用品牌数字化解决方案</p>
              <div class="link" @click="routerLink('/solution/4')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_05.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农产品交易中心数字化解决方案</p>
              <div class="link" @click="routerLink('/solution/5')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_06.png" alt />
        </li>
      </ul>
    </div>
    <el-dialog :visible.sync="dialogVisible" center title="微信扫一扫分享到朋友圈" width="30%">
      <div class="t_center">
      <qrcode :value="value" :options="{ width: 200 }"></qrcode>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Qrcode from "@chenfengyuan/vue-qrcode";
export default {
  components: {
    qrcode: Qrcode
  },
  data() {
    return {
      item: {},
      value:'',
      dialogVisible: false
    };
  },
  mounted() {
    this.loadData(this.$route.params.id)
  },
  created() {},
  methods: {
    routerLink(url) {
      this.$router.push(url);
    },
    shareWx() {
      this.dialogVisible = true
      let host = window.location.host;
      console.log(host,'==',this.$route.path)
      this.value = "https://"+host+this.$route.path
    },
    loadData(id) {
      if(id) {
      this.$store
        .dispatch("api/selContentDetailByAdId", {
          id: id,
        })
        .then(response => {
          if(response ) {
            this.item = response
          }
        })
        .catch(() => {
        });
    }
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/pc/css/news.scss";
.details {
      margin: 5px 0 50px;
      padding: 0 100px;
      line-height: 24px;
      font-size: 14px;
      color: #666;
      img {
        margin: 25px auto;
        display: block;
      }
    }
</style>